import React from 'react';
import { usePageTitle } from '../hooks';
import IdeasContainer from '../components/ideas/IdeasContainer';

const IdeasPage: React.FC = () => {
  // Set page title
  usePageTitle('Ideas');

  return <IdeasContainer />;
};

export default IdeasPage;